const LINKS_KEY = 'jarvis.spreadsheetEditor.cellLinksVisible';

function readBool(key: string, defaultValue = true): boolean {
  try {
    const v = localStorage.getItem(key);
    if (v === '0') return false;
    if (v === '1') return true;
  } catch {
    /* ignore */
  }
  return defaultValue;
}

function writeBool(key: string, value: boolean): void {
  try {
    localStorage.setItem(key, value ? '1' : '0');
  } catch {
    /* ignore */
  }
}

export function readSpreadsheetCellLinksVisible(): boolean {
  return readBool(LINKS_KEY, true);
}

export function writeSpreadsheetCellLinksVisible(visible: boolean): void {
  writeBool(LINKS_KEY, visible);
}
